/* Gout listicle (run 09): CTA query passthrough, lazy autoplay loops, missing-media fallback.
   Shared by layout/theme.listicle-gout.liquid and the local preview.html. */
(function () {
  'use strict';

  /* Forward utm_* and fbclid from the landing URL onto every CTA, without overriding params the link already sets. */
  var here = new URLSearchParams(location.search);
  document.querySelectorAll('a[data-lst-pass-query]').forEach(function (a) {
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      here.forEach(function (v, k) {
        if (!/^utm_/i.test(k) && k !== 'fbclid') return;
        if (u.searchParams.has(k)) return;
        u.searchParams.set(k, v);
      });
      a.setAttribute('href', u.origin === location.origin ? u.pathname + u.search + u.hash : u.href);
    } catch (e) {}
  });

  /* An <img> that 404s turns its figure into a labelled placeholder instead of a broken-image icon. */
  document.querySelectorAll('.lst-fig img').forEach(function (img) {
    function fail() {
      var fig = img.closest('.lst-fig');
      if (fig) fig.classList.add('lst-fig--ph');
      img.hidden = true;
      if (fig && !fig.querySelector('.lst-ph')) {
        var s = document.createElement('span');
        s.className = 'lst-ph';
        s.textContent = '[image missing: ' + (img.getAttribute('alt') || img.getAttribute('src')) + ']';
        fig.appendChild(s);
      }
    }
    if (img.complete && img.naturalWidth === 0 && img.getAttribute('loading') !== 'lazy') fail();
    else img.addEventListener('error', fail);
  });

  /* Silent loops: attach the source when near the viewport, play while visible, pause when not. */
  var loops = document.querySelectorAll('video[data-lst-loop]');
  function attach(v) {
    if (v.dataset.lstReady) return;
    v.dataset.lstReady = '1';
    var src = v.getAttribute('data-src');
    if (src) { v.src = src; v.load(); }
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { attach(v); play(v); } else if (!v.paused) { v.pause(); }
      });
    }, { rootMargin: '300px 0px' });
    loops.forEach(function (v) { io.observe(v); });
  } else {
    loops.forEach(function (v) { attach(v); play(v); });
  }

  /* Offer countdown: HH:MM:SS to the visitor's local midnight (same behaviour as the PDP v2 timer). */
  var cds = document.querySelectorAll('[data-lst-countdown]');
  if (cds.length) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      cds.forEach(function (el) { el.textContent = txt; });
    };
    tick();
    setInterval(tick, 1000);
  }
})();
